import React from "react";
import { twMerge } from "tailwind-merge";

type TextInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, ...rest }, ref) => {
    return (
      <input
        ref={ref}
        className={twMerge(
          "w-full rounded-[10px] border border-line-subtle bg-surface-inset px-3.5 py-2.5 text-sm text-ink-primary placeholder:text-ink-muted outline-none transition-shadow focus:border-brand-to focus:ring-2 focus:ring-brand-soft/40",
          className
        )}
        {...rest}
      />
    );
  }
);

TextInput.displayName = "TextInput";

export default TextInput;
